import ContractCard from './Contract.vue';

export default ContractCard;



// WEBPACK FOOTER //
// ./src/pages/profile/blocks/cards/contract/index.ts